import React from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { Employee } from '../../shared/types.js';
import Button from '../components/Button';
import { ChevronLeftIcon } from '../components/icons';
import DetailReportGenerator from '../components/DetailReportGenerator';

const EmployeeReportScreen: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const employee = location.state?.employee as Employee;

    if (!employee) {
        return <Navigate to="/" />;
    }

    const displayName = `${employee.firstName} ${employee.lastName}`.trim();

    return (
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900 p-4 md:p-8 select-none">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
                    <div className="flex items-center gap-4">
                        <Button variant="ghost" onClick={() => navigate(-1)} className="p-2">
                           <ChevronLeftIcon className="w-6 h-6" />
                           <span className="sr-only">Back</span>
                        </Button>
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
                           Timecard Report for {displayName}
                        </h1>
                    </div>
                </div>
                
                <DetailReportGenerator initialFilterEmployeeId={employee.id} isEmployeeView={true} />

            </div>
        </div>
    );
};

export default EmployeeReportScreen;